import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import shopActions from 'services/shop/actions';
import shopSelectors from 'services/shop/selectors';

const useGetCleaningFee = (lazy?: boolean) => {
    const dispatch = useAppDispatch();
    const data = shopSelectors.data.cleaningFeeV2();

    const mutate = () => {
        dispatch(shopActions.get.cleaningFeeV2.fetch());
    };

    useEffect(() => {
        if (!lazy) {
            mutate();
        }
    }, []);

    return [data, mutate] as const;
};

export default useGetCleaningFee;
